import { ErrorBoundary } from '@sentry/react';
import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/guards/auth';
import DashboardLayout from 'src/layouts/dashboard';
import SentryErrorPage from 'src/pages/SentryErrorPage';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const KbReaderLayout = lazy(
  () => import('src/sections/knowledge-base/view/kb-reader-layout')
);
const KbReaderHomeView = lazy(
  () => import('src/sections/knowledge-base/view/kb-reader-home-view')
);
const KbReaderArticleView = lazy(
  () => import('src/sections/knowledge-base/view/kb-reader-article-view')
);
const KbReaderSearchView = lazy(
  () => import('src/sections/knowledge-base/view/kb-reader-search-view')
);
// Category landing is the search view filtered by category — see
// paths.help.category. There's no dedicated KbReaderCategoryView in v1.

// ----------------------------------------------------------------------

export const knowledgeBaseRoutes = [
  {
    path: 'help',
    element: (
      <ErrorBoundary fallback={<SentryErrorPage />}>
        <AuthGuard>
          <DashboardLayout>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
          </DashboardLayout>
        </AuthGuard>
      </ErrorBoundary>
    ),
    children: [
      {
        element: <KbReaderLayout />,
        children: [
          { index: true, element: <KbReaderHomeView /> },
          { path: 'search', element: <KbReaderSearchView /> },
          { path: 'd/:slug', element: <KbReaderArticleView /> },
        ],
      },
    ],
  },
];
